import { render, staticRenderFns } from "./PCard.vue?vue&type=template&id=061b2082&scoped=true"
import script from "./PCard.vue?vue&type=script&lang=ts"
export * from "./PCard.vue?vue&type=script&lang=ts"
import style0 from "./PCard.vue?vue&type=style&index=0&id=061b2082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061b2082",
  null
  
)

export default component.exports